// para poder utlizar el route y el switch o Router
import { useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from 'react-router-dom'
// importo mi componentes
import Admin from './components/Admin';
import Login from './components/Login';
import Navbar from './components/Navbar';
import Reset from './components/Reset';

// importo el auth para poder preguntar si el usuario esta logeado o no
import { auth } from './firebase'





function App() {

  // creo un estado para poder traernos la informacion del usuario
  const [firebaseUser, setFirebaseUser] = useState(false)


  // creo un useEffect ---> para que cuando cargue nuestro componente ejecute una vez para saber si en verdad el usuario esta o no logeado
  useEffect(() => {

    // onAuthStateChanged(usuario) --> esa funcion recibe un usuario
    auth.onAuthStateChanged(user => {
      // pinto el usuario
      console.log(user)

      // como tenemos un usuario activo lo importante es preguntar
      // preguntamos si existe un usuario
      if (user) {
        // guardo el usuario al estado
        setFirebaseUser(user)
      } else {
        // si no existe el usuario
        // haga el usuario en null porque esta en false
        setFirebaseUser(null)
      }

    })

    // [] ---> para que se ejcute una sola vez
  }, [])



  // PREGUNTO SI no firebaseUser ---> existe, pinte eso  
  return firebaseUser !== false ? (
    // para pder hacer las 
    <Router>
      <div className="container">
        {/* <h1>Auth</h1> */}

        {/* Hago mi navbar */}
        {/* Navbar... */}
        {/* como en mi estado tengo
         mi informacion de mi usuario, 
         se la paso a mi navbar para poder 
         utilizar esa informacion y obtenerla 
         en mi componente */}
        <Navbar firebaseUser={firebaseUser} />

        {/* Para poder cambiar mis rutas */}
        <Switch>
          {/* rutas dinamicas */}

          {/* rutas de login */}
          <Route path="/login">
            {/* Componente de login */}
            {/* login... */}
            <Login />
          </Route>
          {/* rutas de admin */}
          <Route path="/admin">
            {/* Componente de admin */}
            {/* admin... */}
            <Admin />
          </Route>
          {/* rutas de reset-password */}
          <Route path="/reset">
            {/* Componente de reset */}
            {/* reset... */}
            <Reset />
          </Route>
          {/* rutas de ruta home */}
          <Route path="/" exact>
            {/* Componente de home */}
            inicio...
            {/* <Inicio /> */}
          </Route>
        </Switch>


      </div>
    </Router>


  ) : (
    // si eso esta en falso, pinte cargando
    <p>Cargando...</p>
  )
}

export default App;
